import styled from 'styled-components';

export const ModalBodyContainer = styled.div`
    background: white; 
    padding-top: 15px;
    height: 300px;
    max-height: 350px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const FieldTitles = styled.text`
    font-weight: bold
`;

export const FieldDescriptiveNote = styled.text`
    color: grey;
    font-size: 12px
`;